<div class="content">
    <div class="equalizer" style="--eqz:{{value}}">
        <input type="range" value="0" autocomplete="off" max="100" step="10"
               [(ngModel)]="value"
               (ngModelChange)="valueChange.emit($event)"
               class="equalizer-range">
        <div class="number"></div>
    </div>
</div>
